import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/Button/Button';
import Spinner from '../../../components/Spinner/Spinner';
import styles from '../ForgotPassword.module.scss';

interface EmailProps {
  values: { email: string };
  errors: { email?: string; form?: string };
  emailError: string;
  submitting: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  handleRecoveryByUsername: () => void;
  recoveryLoading: boolean;
}

const EmailVerificationForm: React.FC<EmailProps> = ({
  values,
  errors,
  emailError,
  submitting,
  handleChange,
  handleSubmit,
  handleRecoveryByUsername,
  recoveryLoading,
}) => {
  const { t } = useTranslation('account');

  return (
    <>
      <form onSubmit={handleSubmit} noValidate>
        <div className={styles.field}>
          <label htmlFor="forgot-email" className={styles.fieldLabel}>
            {t('reset.email')}
            <span className={styles.required} aria-hidden>
              *
            </span>
          </label>
          <div className={styles.inputWrap}>
            <input
              id="forgot-email"
              name="email"
              type="email"
              className={styles.input}
              value={values.email}
              onChange={handleChange}
              placeholder={t('reset.email_placeholder')}
              required
              aria-invalid={!!errors.email || !!emailError}
            />
          </div>
          {(errors.email || emailError) && (
            <p className={styles.helperError} role="alert">
              {errors.email || emailError}
            </p>
          )}
        </div>
        <Button type="submit" className={styles.submit} color="primary" fullWidth size="large" disabled={submitting} label={t('reset.send_code')} />
      </form>
      <div
        className={styles.recoveryLink}
        onClick={handleRecoveryByUsername}
        style={{ opacity: values.email ? 1 : 0.5, pointerEvents: values.email ? 'auto' : 'none' }}
      >
        {recoveryLoading ? <Spinner size="small" /> : t('reset.dont_know_username')}
      </div>
    </>
  );
};

export default EmailVerificationForm;
